import bookData from './bookData.json';
import { BookData } from './Types';

const Book: BookData = bookData;

export default Book;
